<template>

  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
  >
  </form-edit-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import CalculateBudgetingPlannerPMRecord from "@/components/forms/customizations/plm/CalculateBudgetingPlannerPMRecord";


const FORM_TYPE = BudgetingPlannerPM;
const CALC_PLANNER_PM = new CalculateBudgetingPlannerPMRecord();

export default {
  name: "BudgetingPlannerPMEditor",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props: {
    entityId: {default: null},
    mode: {type: String, default: "NEW"}
  },

  async created() {
  },

  async mounted() {
    // this.afterStart(async () => {
    // setTimeout(async () => {
    // })
    // });
  },

  methods: {
    ...Activity.methods,

    async canClose() {
      this.form.fields.totalQuantity.value = null;
      this.form.fields.sellingValue.value = null;
      this.form.fields.purchaseValue.value = null;
      this.form.fields.sellingValueOnline.value = null;
      this.form.fields.onlinePurchaseValue.value = null;
      this.form.fields.sellingValueTotal.value = null;
      this.form.fields.purchaseValueTotal.value = null;

      return this.$refs.formEditor.canClose();
    },

    getTitle() {
      if (this.mode === "NEW") {
        return "New " + this.formConfig.entityName;
      } else {
        return this.$refs.formEditor?.title;
      }
    },

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
      await this.afterMounted();
    },

    async afterMounted() {
      this.plannerPM = await Rpc.Forms.getEntity(this.form.formConfig.formClassLong, this.entityId);
      await CALC_PLANNER_PM.calculatePlannerWithProduct(this.plannerPM);
      this.form.fields.totalQuantity.value = this.plannerPM.totalQuantity;
      this.form.fields.sellingValue.value = this.plannerPM.sellingValue;
      this.form.fields.purchaseValue.value = this.plannerPM.purchaseValue;
      this.form.fields.sellingValueOnline.value = this.plannerPM.sellingValueOnline;
      this.form.fields.onlinePurchaseValue.value = this.plannerPM.onlinePurchaseValue;
      this.form.fields.sellingValueTotal.value = this.plannerPM.sellingValueTotal;
      this.form.fields.purchaseValueTotal.value = this.plannerPM.purchaseValueTotal;
    },

  },

  watch: {
    "form.fields.quantityPOS.value": async function (val) {
      this.form.fields.totalQuantity.value = val + this.form.fields.onlineQuantity.value;
    },
    "form.fields.onlineQuantity.value": async function (val) {
      this.form.fields.totalQuantity.value = val + this.form.fields.quantityPOS.value;
    },
    "form.fields.sellingValue.value": async function (val) {
      if (val == null) {
        this.form.fields.sellingValue.value = this.plannerPM?.sellingValue;
      }
    },
    "form.fields.purchaseValue.value": async function (val) {
      if (val == null) {
        this.form.fields.purchaseValue.value = this.plannerPM?.purchaseValue;
      }
    },
    "form.fields.sellingValueOnline.value": async function (val) {
      if (val == null) {
        this.form.fields.sellingValueOnline.value = this.plannerPM?.sellingValueOnline;
      }
    },
    "form.fields.onlinePurchaseValue.value": async function (val) {
      if (val == null) {
        this.form.fields.onlinePurchaseValue.value = this.plannerPM?.onlinePurchaseValue;
      }
    },
    "form.fields.sellingValueTotal.value": async function (val) {
      if (val == null) {
        this.form.fields.sellingValueTotal.value = this.plannerPM?.sellingValueTotal;
      }
    },
    "form.fields.purchaseValueTotal.value": async function (val) {
      if (val == null) {
        this.form.fields.purchaseValueTotal.value = this.plannerPM?.purchaseValueTotal;
      }
    },
  },

  data: function () {
    return {
      FORM_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
      plannerPM: null
    }
  }
}
</script>
